export default __webpack_public_path__ + "static/media/hp-logo_old.2402b8f1.svg";